import ReactDOM from 'react-dom';
import './index.css';

// Components
import App from './App';

ReactDOM.render(<App/>, document.querySelector('#root'));
